import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    const targetId = hash ? decodeURIComponent(hash.slice(1)) : ''
    const target = targetId ? document.getElementById(targetId) : null

    if (target) {
      target.scrollIntoView({ behavior: 'instant', block: 'start' })
      return
    }

    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname, hash])

  return null
}
